import {
    createBrowserRouter
} from "react-router-dom";
import Main from "../layout/Main";
import ErrorPage from "../Pages/ErrorPage/ErrorPage";
import Home from "../Pages/Home/Home";

import Contact from "../Pages/Contact/Contact";
import ServiceDetails from "../Pages/Services/ServiceDetails/ServiceDetails";
import Services from "../Pages/Services/Services";

export const routes = createBrowserRouter([
    {
        path: '/',
        element: <Main></Main>,
        children: [
            {
                path: '/',
                element: <Home></Home>
            },
            {
                path: '*',
                element: <ErrorPage></ErrorPage>
            },
            {
                path: '/services',
                element: <Services></Services>
            },
            {
                path: '/contact',
                element: <Contact />
            },
            {
                path: '/services/:id',
                loader: ({ params }) => fetch(`https://my-portfolio-server-wine-six.vercel.app/services/${params.id}`),
                element: <ServiceDetails></ServiceDetails>
            }
        ]
    }
])